// extracted by mini-css-extract-plugin
module.exports = {"info":"ArtistIndexPosterInfo-info-3J_DB"};